import { Button, Textarea } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './FeedbackComment.css';

type FeedbackCommentProp = {
  setComment: (comment: string) => void;
};

export const FeedbackComment: React.FC<FeedbackCommentProp> = ({ setComment }) => {
  const [value, setValue] = React.useState('');

  const handleChange = (e: React.ChangeEvent, value: string) => {
    setValue(value);
  };

  return (
    <div className={styles['container']}>
      <Textarea value={value} size="M" placeholder="Расскажите, что нам стоит улучшить" onChange={handleChange} />
      <Button onClick={() => setComment(value)} theme="fill_secondary" fullWidth>
        Отправить
      </Button>
    </div>
  );
};
